module.exports = "# Sizzle\n\n## Content\n\n### Activité 1 : Remue-méninges d'équipe!\n\n## Notes\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Instructions\n* En équipe, dressez une liste de tous les mots qui décrivent l'eau. Trouvez-en le plus possible en 2 minutes.\n* Quel est l'aspect physique de l'eau? Son goût, son odeur, sa texture (p. ex., « mouillé »).\n* Un point pour chaque mot!\n\n## Notes\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/sections/30_classActivity/level1a_teamBrainstorm.fr_CA.md
// module id = 1695
// module chunks = 2